import React from "react";
import { Discover } from "pages";

const DiscoverRoute = () => {
  return (
    <>
      <Discover />
    </>
  );
};

export default DiscoverRoute;
